import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-acb3cd2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-comment me-2" }, null, -1))
const _hoisted_2 = { class: "row px-3" }
const _hoisted_3 = { class: "col-3 d-flex justify-content-center align-items-center" }
const _hoisted_4 = { class: "photo text-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-9" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "userName",
  class: "form-label text-muted"
}, " ชื่อผู้รายงานผล: ", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "role",
  class: "form-label text-muted"
}, " สิทธิ์การใช้งาน: ", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "px-3" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-save" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseModalComponent = _resolveComponent("BaseModalComponent")!

  return (_openBlock(), _createBlock(_component_BaseModalComponent, {
    ref: "enjoinAnswerForm",
    backdrop: "static",
    onHide: _ctx.clearForm
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode("รายงานผลการสั่งการหรือเร่งรัดโครงการ ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "img-fluid rounded-circle profile-image mb-2",
              src: _ctx.account?.avatar,
              alt: "avatar"
            }, null, 8, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("input", {
              type: "text",
              value: `${_ctx.account?.firstName} ${_ctx.account?.lastName}`,
              class: "form-control",
              "aria-label": "userName",
              readonly: ""
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("input", {
              type: "text",
              value: _ctx.role?.name,
              class: "form-control",
              "aria-label": "role",
              readonly: ""
            }, null, 8, _hoisted_12)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", {
            for: "description",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.description}])
          }, " รายละเอียด: ", 2),
          (_ctx.submited && _ctx.errors.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, " * กรุณาป้อนรายละเอียด "))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("textarea", {
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.description}]),
            placeholder: "กรุณาป้อนรายละเอียด...",
            "aria-label": "description",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.description) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
          }, "\n          ", 34), [
            [
              _vModelText,
              _ctx.formData.description,
              void 0,
              { trim: true }
            ]
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        _hoisted_16,
        _createTextVNode(" ปิด ")
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, [
        _hoisted_17,
        _createTextVNode(" บันทึก ")
      ])
    ]),
    _: 1
  }, 8, ["onHide"]))
}